export function getScaleFromMatrix(matrix: string) {
  // The matrix is returned as a string like "matrix(a, b, c, d, e, f)" or
  // "matrix3d(...)" for 3D transforms

  // For 2D transforms (matrix)
  if (matrix.startsWith('matrix(')) {
    // Extract the values from the matrix string
    const values = matrix.match(/matrix\((.+)\)/)?.[1]?.split(', ') || [];

    // For 2D transform matrix, the scale values are at positions 0 and 3
    // matrix(scaleX, 0, 0, scaleY, translateX, translateY)
    return {
      scaleX: parseFloat(values[0]),
      scaleY: parseFloat(values[3]),
    };
  }

  // For 3D transforms (matrix3d)
  if (matrix.startsWith('matrix3d(')) {
    const values = matrix.match(/matrix3d\((.+)\)/)?.[1]?.split(', ') || [];

    // For 3D matrix, scale values are at positions 0, 5, and 10
    return {
      scaleX: parseFloat(values[0]),
      scaleY: parseFloat(values[5]),
      scaleZ: parseFloat(values[10]),
    };
  }

  // If no transform is applied
  return { scaleX: 1, scaleY: 1 };
}
